import React from 'react';
import { motion } from 'framer-motion';

// Plante bien-être qui pousse avec la progression globale (0 → 1).
// graine → pousse → plante → plante fleurie.
export default function Plant({ ratio = 0, size = 132 }) {
  const r = Math.max(0, Math.min(1, ratio));
  const stemTop = 150 - r * 92; // plus r est grand, plus la tige monte
  const showLeaf1 = r >= 0.18;
  const showLeaf2 = r >= 0.42;
  const showLeaf3 = r >= 0.66;
  const flower = r >= 0.99;

  const ease = [0.4, 0, 0.2, 1];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 160 170"
      role="img"
      aria-label="Plante de progression"
    >
      {/* Pot */}
      <path
        d="M52 150 L108 150 L102 168 L58 168 Z"
        fill="#C08457"
      />
      <rect x="48" y="144" width="64" height="10" rx="3" fill="#D49A6E" />

      {/* Terre */}
      <ellipse cx="80" cy="149" rx="28" ry="4" fill="#6B5440" />

      {/* Graine (visible au tout début) */}
      {r < 0.18 && (
        <motion.ellipse
          cx="80"
          cy="146"
          rx="5"
          ry="7"
          fill="#8A6A4A"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
        />
      )}

      {/* Tige */}
      <motion.line
        x1="80"
        y1="150"
        x2="80"
        y2={stemTop}
        stroke="#8A9A82"
        strokeWidth="5"
        strokeLinecap="round"
        initial={false}
        animate={{ y2: stemTop }}
        transition={{ duration: 0.8, ease }}
      />

      {/* Feuilles */}
      {showLeaf1 && (
        <motion.path
          d="M80 128 C64 124 56 110 60 100 C74 104 82 116 80 128 Z"
          fill="#8A9A82"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease }}
          style={{ transformOrigin: '70px 114px' }}
        />
      )}
      {showLeaf2 && (
        <motion.path
          d="M80 112 C96 108 104 94 100 84 C86 88 78 100 80 112 Z"
          fill="#9FB096"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease }}
          style={{ transformOrigin: '90px 98px' }}
        />
      )}
      {showLeaf3 && (
        <motion.path
          d="M80 96 C66 92 58 80 62 71 C75 75 82 86 80 96 Z"
          fill="#8A9A82"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease }}
          style={{ transformOrigin: '70px 84px' }}
        />
      )}

      {/* Fleur (à 100 %) */}
      {flower && (
        <motion.g
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease, delay: 0.1 }}
          style={{ transformOrigin: `80px ${stemTop}px` }}
        >
          {[0, 72, 144, 216, 288].map((deg) => (
            <ellipse
              key={deg}
              cx="80"
              cy={stemTop - 9}
              rx="6"
              ry="11"
              fill="#C9A86A"
              transform={`rotate(${deg} 80 ${stemTop})`}
            />
          ))}
          <circle cx="80" cy={stemTop} r="6" fill="#C08457" />
        </motion.g>
      )}
    </svg>
  );
}
